module.exports = __webpack_public_path__ + "img/teleg.964ed71.png";